import { TooltipContent } from "../ui/tooltip";

interface CellErrorTooltipContentProps {
  isTimeout: boolean;
  errorMessage?: string;
  /**
   * Replaces the default lead sentence. Callers pass the column-scoped or
   * regeneration lead here (e.g. "This column produced no result for this
   * sample."); omitted, the lead falls back to the timeout / generic error
   * sentence. The backend's own reason still follows either way.
   */
  errorLead?: string;
}

const getErrorMessage = (
  isTimeout: boolean,
  errorMessage?: string,
  errorLead?: string,
): string => {
  const baseMessage =
    errorLead ??
    (isTimeout
      ? "Midship ran out of time generating this cell."
      : "Error generating this cell. Try re-running.");
  return errorMessage ? `${baseMessage} Reason: ${errorMessage}` : baseMessage;
};

/** Body of the failed-cell hover tooltip, shared by `CheckDecision` and
 * `DataCell`. Render inside a `Tooltip` root. */
export const CellErrorTooltipContent = ({
  isTimeout,
  errorMessage,
  errorLead,
}: CellErrorTooltipContentProps) => (
  <TooltipContent className="max-w-xs break-words">
    <p>{getErrorMessage(isTimeout, errorMessage, errorLead)}</p>
  </TooltipContent>
);
